export default __webpack_public_path__ + "static/media/grain.8506e991.svg";